import React from "react";
import { Button } from "react-bootstrap";
import addcallicon from "../assets/images/addcallicon.svg";
const { REACT_APP_STATIC_ASSETS_BASE_URL } = process.env;

class AddNewParticipantButton extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { conferenceSid, user, callSid, from_, addNewParticipant, disabled } =
      this.props;
    return (
      <Button
        className="removecolorbut addcallicon"
        onClick={() =>
          addNewParticipant(conferenceSid, user.identity, callSid, from_)
        }
        disabled={disabled}
      >
        <img alt="" src={`${REACT_APP_STATIC_ASSETS_BASE_URL}${addcallicon}`} />
        <h4>Add call</h4>
      </Button>
    );
  }
}

export default AddNewParticipantButton;
